import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  getActivities,
  removeActivityDialogue
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setActivities
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {removeDialogueApi} from '../api/dialogue';
import {getActivitiesApi} from '../api/activities';

export const loadActivitiesAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getActivities;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getActivitiesApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setActivities(data));
    } catch (e) {
      console.log('loadActivitiesAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadActivitiesAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeActivityDialogueAction = (dialogueId: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeActivityDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueApi(dialogueId);
      dispatch(loadActivitiesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('removeActivityDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveActivityDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});
